import { useState, useEffect } from 'react'
import { getNewsCategories } from '@domain/features/news/news-feature'
import type { NewsCategory } from '@domain/models/news-category'

export function useNewsCategories() {
  const [categories, setCategories] = useState<NewsCategory[]>([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    let cancelled = false

    async function load() {
      try {
        const result = await getNewsCategories()
        if (!cancelled) setCategories(result)
      } catch {
        // Categories are non-critical; fail silently
      } finally {
        if (!cancelled) setLoading(false)
      }
    }

    load()
    return () => { cancelled = true }
  }, [])

  return { categories, loading }
}

// Backward compatible alias for legacy imports.
export const useMainCategories = useNewsCategories
